import React, { useContext } from "react";
import Carousel from "~components/Carousel";
import { DocumentContext } from "~context/DocumentContext";
import { Link } from "gatsby";

const ProductFeatures = ({ heading, features }) => {
  const { device } = useContext(DocumentContext);

  return (
    <div className="w-full relative bg-off-white">
      <section>
        {heading && (
          <div className="text-center mt-v8 mb-v10 px-20 xs:px-5 w-full">
            <h2 className="mt-v05 f2 xs:f2"> {heading} </h2>
          </div>
        )}
        {device !== `mobile` && features.length != 0 && (
          <div className="grid-end-12 mt-v3 mb-v5 grid">
            {features.map((feature, index) => {
              let careInstructions = false;
              let text = feature.text;
              if(feature.text.search("(Clicks through to care instructions).") != -1){
                text = feature.text.replace("(Clicks through to care instructions).", "");
                careInstructions = true;
              }
              return (
              <div
                className="text-left flex flex-col items-center gap-5 grid-end-4 grid-end-4"
                key={`product-feature-${index}`}
              >
                <img
                  src={feature.icon.asset.url}
                  alt="icon"
                  className="max-w-xs"
                />
                <p className="b2 max-w-xs mt-v1">{text}
                {careInstructions && (
                  <Link
                    to="/care-instructions"
                    className="b2 max-w-xs mt-v1 underline"
                  >
                    (Clicks through to care instructions).
                  </Link>
                )}
                </p>
              </div>
              );
            })}
          </div>
        )}

        {device === `mobile` && features.length != 0 && (
          <div className="px-5 my-20">
            <Carousel
              items={features.map((feature, index) => {
                const key = `product-feature-${index}`;
                let careInstructions = false;
                let text = feature.text;
                if(feature.text.search("(Clicks through to care instructions).") != -1){
                  text = feature.text.replace("(Clicks through to care instructions).", "");
                  careInstructions = true;
                }

                return (
                  <div
                    className="w-full relative text-left flex flex-col items-center"
                    key={key}
                  >
                    <img src={feature.icon.asset.url} alt="icon" className="" />
                    <p className="b2 mt-10 w-4/5 text-center">{text}
                      {careInstructions && (
                      <Link
                        to="/care-instructions"
                        className="b2 mt-10 w-4/5 text-center underline"
                      >
                        (Clicks through to care instructions).
                      </Link>
                      )}
                    </p>
                  </div>
                );
              })}
              withBullets
            />
          </div>
        )}
      </section>
    </div>
  );
};

export default ProductFeatures;
